module.exports = __webpack_public_path__ + "img/card.ab8ab5b1.png";